import './variablePicker.less';

import React from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';
import { Dropdown, MenuProps } from 'antd';
import { FunctionOutlined } from '@ant-design/icons';

import { i18n } from 'core/localization';
import { useDefaultZIndex } from 'framework/react-integration';
import { CssVariables } from 'styles/cssVariables';
import { AntButton } from 'controls/react/ant/antButton';

import { getVariableChoices } from '../../utils/getVariableChoices';
import { VariableLabel } from '../variable-label/variableLabel';
import { VariablePickerProps } from './types';

const b = b_.with('variable-picker');

export const VariablePicker = observer(({ variables, type, list, onPick, children }: VariablePickerProps) => {
	const overlayStyle = useDefaultZIndex(undefined, CssVariables.zIndexControlPopover);
	if (variables == null) {
		return <>{children}</>;
	}

	const items: MenuProps['items'] =
		variables.length == 0
			? [{ key: '', label: i18n('No variables yet'), disabled: true }]
			: getVariableChoices(variables, type, list).map(({ variable, suitable }) => ({
					key: variable.id,
					label: <VariableLabel variable={variable} />,
					disabled: !suitable,
				}));

	return (
		<div className={b()}>
			{children}
			<Dropdown
				menu={{ items, onClick: ({ key }) => onPick(key) }}
				trigger={['click']}
				overlayStyle={overlayStyle}
			>
				<AntButton icon={<FunctionOutlined />} title={i18n('Use a variable')} />
			</Dropdown>
		</div>
	);
});
